import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../api/services/project.services';
import { TaskConfirmationDialogComponent } from '../dashboard-my-oasis/project-order-summary/task-confirmation-dialog/task-confirmation-dialog.component';
import { PaginatedRequest } from '../../api/models/paginated-request';
import { TasksService } from '../../api/services/tasks.service';
import { MyTasks, Task } from '../../api/models/task';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { HeaderService } from '../header/header.service';
import { Worksheet } from '../../api/models/worksheet';
import { ProjectOrderInput } from '../../api/models/project-summary';
import { AnalyticsService } from '../../api/services/analytics.service';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit {

  loading = true;
  page = 1;
  pageSize = 15;
  totalRecords = 0;
  
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  taskData: any[];
  dataToDisplay: any[];
  result;
  infoMsg = ['No records found!'];

  currentStatusFilter: string = 'PENDING';
  paginatedRequest: PaginatedRequest;
  sorting: string = 'status,date_opened,desc';
  startDate;
  endDate;
  myTasks: MyTasks;
  currentMarketId: string;
  selectedTaskType: string = 'ALL';
  isModalOpen:boolean = false;
  
  constructor(
    private modalService: NgbModal,
    private projectService: ProjectService,
    private tasksService: TasksService,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private router: Router,
    public datePipe: DatePipe,
    private toastr: ToastrService,
    private headerService: HeaderService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.setInitialMinAndMaxDate();
    this.preferencesService.getPreferences('USER', this.authService.getUserId()).subscribe(prefs => {
      this.currentMarketId = prefs['current-market'].Value;
      this.loadPage(1);
    });
    this.headerService.tasksCount.next(true);
  }

  setInitialMinAndMaxDate() {
    // Setting Minimum date
    var today = new Date();
    this.minDate = {year: today.getFullYear()-2, month: today.getMonth()+1, day: today.getDate() };
    
    // Setting Maximum date
    today = new Date();
    this.maxDate = {year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() };

    this.endDate = new Date();
    this.startDate = new Date();
    var previousDate = this.startDate.getDate() - 29 ;
    this.startDate.setDate(previousDate);
  }

  openTaskDialog(data){
    if(!this.isModalOpen){
      this.isModalOpen = true;
      
      if(data.status === 'CLOSED'){
        this.toastr.info('Task is already closed.', 'Info');
        return;
      }
      
      let task = this.setTaskDataforDialog(data);
      if (data.taskType === 'CABLE CUT') {
        this.projectService.getBomLinesByBomlineID(data.bomLineID).subscribe(line => {
          const modalRef = this.modalService.open(TaskConfirmationDialogComponent, {
            backdrop: 'static',
            keyboard: false
          });
          modalRef.componentInstance.task = task;
          modalRef.componentInstance.line = line[0];
          modalRef.result.then(result => {
            if(result){
              this.changeStatus(task);
            }
          }).catch(() => {
            //Empty catch block
          });
        });
      } else if(data.taskType === 'APPROVAL'){
        this.goToWorksheet(data.worksheetID);
      } else if(data.taskType === 'RECEIPT OF GOODS'){
        this.goToOrderConfirmation(data.projectName, data.accountNumber, data.orderNumber);
      } else {
        const modalRef = this.modalService.open(TaskConfirmationDialogComponent, {
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.task = task;
        modalRef.result.then(result => {
          if(result){
            this.changeStatus(task);
          }
        }).catch(() => {
          //Empty catch block
        });
      }
    }
    setTimeout(() => {
      this.isModalOpen = false;
    }, 1500);
  }

  changeStatus(task: Task){
    const selectedTask = this.taskData.find(t => t.id === task.id);
    selectedTask.closed = true;
    selectedTask.opened = false;
    selectedTask.status = 'CLOSED';
    selectedTask.dateClosed = new Date();
    this.headerService.tasksCount.next(true);
  }

  setTaskDataforDialog(data){
    let task = new Task();
    task.id = data.id;
    task.accountNumber = data.accountNumber;
    task.bomLineID = data.bomLineID;
    task.closed = data.closed;
    task.opened = data.opened;
    task.orderNumber = data.orderNumber;
    task.projectName = data.projectName;
    task.receiptOfGoodsID = data.receiptOfGoodsID;
    task.taskType = data.taskType;
    task.worksheetID = data.worksheetID;
    return task;
  }

  setStatus(status: string) {
    if(status === 'ALL'){
      this.currentStatusFilter = status;
    }else{
      this.currentStatusFilter = (status === 'OPEN') ? 'PENDING' : 'CLOSED';
    }
  }

  setTaskType(taskType: string) {
    this.selectedTaskType = taskType;
  }
    
  loadPage(page: number) {
    this.loading = true;
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.myTasks = this.setInputSearchValues();
    this.tasksService.getMyTasks(this.myTasks, this.paginatedRequest).subscribe(result => {
        if (result){
          this.result = result;
          this.taskData = this.result.records;
          this.dataToDisplay = this.taskData;
          this.totalRecords = result.totalRecords;
        }
        this.loading = false;
      },error => {
        this.loading = false;
      });
  }

  goToWorksheet(worksheetID: string){
    this.projectService.getWorksheet(worksheetID).subscribe(ws => {
      this.navigateToWorksheet(ws);
    });
  }

  private navigateToWorksheet(ws : Worksheet) {
    if (!(ws.isQuoted && ws.isQuoted === true) && (ws.orderNumber === undefined || ws.orderNumber === null)) {
      this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', ws.id] } }]);
        //{ queryParams: { backToSearch: 'y' } });
    } else if (ws.orderNumber === undefined || ws.orderNumber === null) {
      this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['checkout', ws.id] } }]);
        //{ queryParams: { backToSearch: 'y' } });
    } else {
      let projectOrderInputs = new ProjectOrderInput(ws.project.name, ws.project.accountNumber, ws.orderNumber, localStorage.getItem("marketLocationCode") );
      this.projectService.getOrderConfirmationV2(projectOrderInputs).subscribe(result => {
        let confirmedOrder = result.orders[0];
        if (confirmedOrder && ws.project.name && ws.project.accountNumber) {
          this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-confirmation', ws.project.name, ws.project.accountNumber, ws.orderNumber] } }]);
            //{ queryParams: { backToSearch: 'y' } });
        } else {
          this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['confirmedOrder', ws.id] } }]);
            //{ queryParams: { backToSearch: 'y' } });
        }
      });
    }
  }

  goToOrderConfirmation(projectName: string, accountNumber: string, orderNumber: string) {
    this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-confirmation', projectName, accountNumber, orderNumber] } }]);
  }

  searchTasks(){
    this.loadPage(1);
    this.sendDataToAnalytics();
  }

  private sendDataToAnalytics() {
    this.analyticsService.trackTaskSearch(this.selectedTaskType);
  }

  setInputSearchValues(){
    var tasks = new MyTasks();
    tasks.marketId = this.currentMarketId;
    tasks.status = this.currentStatusFilter;
    tasks.taskType = this.selectedTaskType;
    
    var dateValue = this.datePipe.transform(this.startDate, "yyyy-MM-dd'T'");
    tasks.startDate = dateValue.concat("00:00:00.000Z");

    dateValue = this.datePipe.transform(this.endDate, "yyyy-MM-dd'T'");
    tasks.endDate = dateValue.concat("23:59:59.999Z");

    return tasks;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/tasks/tasks.component.ts